function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_button_icon_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_button_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_button_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_button_icon_svg__cls-1",
  d: "M10.75 11.87H2a1.88 1.88 0 110-3.75H10.71L9.53 6.87 7.77 5.11a1.87 1.87 0 01-.05-2.72 1.92 1.92 0 012.69 0q3.09 3.07 6.16 6.16a1.83 1.83 0 010 2.78q-3.09 3.14-6.22 6.23a1.85 1.85 0 01-2.64 0 1.83 1.83 0 010-2.64c.9-.95 1.84-1.86 2.77-2.79z"
}), React.createElement("path", {
  className: "bespoken_button_icon_svg__cls-1",
  d: "M20 10V3.78c0-1.13-.37-1.58-1.49-1.7A9 9 0 0017.1 2c-.78 0-1.21-.29-1.23-1s.35-1 1.13-1h1.74A3.48 3.48 0 0122 3.35V16.6a3.22 3.22 0 01-3.08 3.33c-.66.06-1.33.07-2 .07a1 1 0 01-1.08-1 1 1 0 011.08-1h1.39c1.13 0 1.63-.52 1.64-1.67v-6.32z"
})));

var SvgBespokenButtonIcon = function SvgBespokenButtonIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22.01 20"
  }, props), _ref, _ref2);
};

export default SvgBespokenButtonIcon;